import PropTypes from "prop-types"
import StyledFaqLink from "./StyledFaqLink"
import StyledFaqLinkHeading from "./StyledFaqLinkHeading"

export default function QuestionLink({ faq, sectionSlug, size }) {
  return (
    <StyledFaqLink to={`/help/${sectionSlug}/${faq.slug}`}>
      <StyledFaqLinkHeading size={size} content={faq.data.question} />
    </StyledFaqLink>
  )
}

QuestionLink.propTypes = {
  sectionSlug: PropTypes.string,
  size: PropTypes.oneOf(["h1", "h2", "h3", "h4"]),
  faq: PropTypes.object.isRequired,
}
